import { styled } from '@mui/material';

const Separator = styled('hr', { name: 'Separator ' })(({ theme }) => ({
  border: 0,
  margin: 0,
  flexShrink: 0,
  transition: theme.transitions.create(['background-color'], {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.standard,
  }),
  backgroundColor: 'transparent',

  '&:hover': {
    backgroundColor: theme.palette.custom.OV.sys.outlineVariant,
  },
}));

export const VerticalSeparator = styled(Separator, {
  name: 'VerticalSeparator',
})(() => ({
  maxHeight: '100%',
  width: '0.25rem',
  cursor: 'col-resize',
  alignSelf: 'stretch',
}));

export const BorderVerticalSeparator = styled(VerticalSeparator, {
  name: 'BorderVerticalSeparator',
})(({ theme }) => ({
  width: '1px',
  margin: '-1px',
  backgroundColor: theme.palette.custom.OV.sys.outlineVariant,
  zIndex: 100,
}));

export const HorizontalSeparator = styled(Separator, {
  name: 'HorizontalSeparator',
})(() => ({
  maxWidth: '100%',
  height: '0.25rem',
  cursor: 'row-resize',
  alignSelf: 'stretch',
}));
